<template>
    <div class="vue_basic">
        <h1>{{ props.name }}</h1>
        <form>
            <div>
                <div v-for="(error, error_key) in errors">
                    <div v-for="(message,key) in error">
                        <Message severity="error">{{ error_key }}:{{ message }}</Message>
                    </div>
                </div>
            </div>

            <div class="input_item">
                <div class="p-float-label with-button">
                    <InputText id="name" type="text" v-model="formData.name"/>
                    <label for="name">Name</label>
                </div>
            </div>

            <div class="input_item">
                <div class="p-float-label with-button">
                    <Textarea id="memo" v-model="formData.memo" :autoResize="true" rows="5" cols="30" />
                    <label for="memo">Memo</label>
                </div>
            </div>

            <div class="input_item">
                <div class="input_switch">
                    <InputSwitch v-model="formData.is_public" />
                    <span>{{ formData.is_public ? "public" : "private"}}</span>
                </div>
                <p>
                    {{ $t('You can set it to be public or private.')}}
                </p>

            </div>

            <Button
                type="button"
                :label="$t('update')"
                class="p-button-rounded"
                @click="onClickUpdate"
                />
        </form>
    </div>
</template>

<script>
import {
    ref,
    onMounted,
    reactive,
    computed,
} from 'vue';
import axios from "axios";
import Message from 'primevue/message';

import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Textarea from 'primevue/textarea';
import InputSwitch from 'primevue/inputswitch';

import { useToast } from "primevue/usetoast";

import { trans } from 'laravel-vue-i18n';

export default {
    components: {
        Message,
        Button,
        InputText,
        Textarea,
        InputSwitch,
    },
    props: {
        hash: {
            type: Number,
            default: ""
        },
        name: {
            type: String,
            default: ""
        },
        is_public: {
            type: Boolean,
            default: ""
        },
        memo: {
            tyep: String,
            default: ""
        },
    },
    setup(props) {

        const toast = useToast();
        const errors = ref([]);
        const formData = reactive({
            name: "",
            is_public: true,
            memo: "",
        })



        const load = () => {
            formData.name = props.name;
            formData.is_public = props.is_public;
            formData.memo = props.memo;

        }

        onMounted(load);

        const onClickUpdate = function() {
            Update()
        }

        const Update = function() {
            const postData = {
                name: formData.name,
                is_public: formData.is_public,
                memo: formData.memo,
            }
            axios.post(
                '/api/user/user_item_list/' + props.hash,
                postData,
            ).then(res => {
                toast.add({severity:'info', summary: 'Update', detail:'User Item List Update', life: 3000});
                if(formData.userItemList != props.user_item_list) {
                }

                errors.value = {}
            }).catch(error => {
                toast.add({severity:'error', summary: 'Error', detail: error.response.data.errors, life: 3000});
            })
        }

        return {
            errors,
            onClickUpdate,
            formData,
            props,
        }
    },
}
</script>

